import {NgModule} from '@angular/core';
import {EmailComponent} from "./email.component";

@NgModule({
    declarations: [
        EmailComponent,
    ],
    exports: [
        EmailComponent
    ]
})
export class EmailModule {}
